import React, { useMemo, Dispatch, SetStateAction, useCallback, useRef, useEffect } from 'react'
import { CSSTransition } from 'react-transition-group'

import useFilter from '../../hooks/FilterContext';
import * as S from './styles'

interface IFilterState {
    env: string;
}

interface IFilterItemContentProps {
    filterName: string;
    filterType: 'radio' | any;
    filterCategoryItems?: {
        filterItemName: string;
        filterItemValue: string | number[];
        id: number;
        brands?: {
            filterItemName: string;
            filterItemValue: string;
        }[]
    }[];
    isOpen: boolean;
    filterProperties: IFilterState | any;
    setfilterProperties: Dispatch<SetStateAction<IFilterState>>;
    onClose: () => void;
}

const FilterCategoryItem: React.FC<IFilterItemContentProps> = ({
    filterName,
    isOpen,
    filterType,
    filterCategoryItems,
    setfilterProperties,
    filterProperties,
}) => {

    const nodeRef = useRef(null)
    const { setAttributeHandler } = useFilter()

    const onChangeFilterProperties = useCallback((filterItemValue: any) => (
        setfilterProperties((prevState: any) => ({ ...prevState, [filterName]: filterItemValue }))
    ), [filterName, setfilterProperties])

    useEffect(() => {
        setAttributeHandler(filterProperties.search);
        setfilterProperties((prevState: any) => ({ ...prevState, search: prevState.search ? prevState.search : 'todos' })) 
    }, [filterProperties.search, setAttributeHandler, setfilterProperties])

    const hasProprietes = filterProperties[filterName];

    const onToggleFilterProperties = useCallback((value: any, id) => {
        let div = document.getElementById(id);

        if (filterProperties[filterName] === value) {
            delete filterProperties[filterName];
            setfilterProperties((prevState: any) => ({ ...prevState }))

            div?.classList.remove("checked");
        }
        else {
            onChangeFilterProperties(value)
            div?.classList.add("checked");
        }
    }, [filterName, filterProperties, onChangeFilterProperties, setfilterProperties])

    const paramsFilter = useCallback((filterItem, children) => {
        const checked = JSON.stringify(filterProperties[filterName]) === JSON.stringify(filterItem.filterItemValue)

        switch (filterName) {
            case 'search': {
                return (
                    <div key={filterItem.filterItemName} >
                        <S.Button
                            onClick={() => {
                                onChangeFilterProperties(filterItem.filterItemValue);
                            }}
                            style={checked ? { background: '#DBC7B8', color: '#424242' } : { background: 'transparent' }}
                            type={filterType}
                        >
                            {children}
                        </S.Button>

                    </div>
                )
            }
            case 'category': {
                return (
                    <div key={filterItem.filterItemName} >
                        <S.Button
                            className={hasProprietes === `${filterItem.id}/${filterItem.filterItemValue}` ? 'checked' : ''}
                            id={filterItem.filterItemValue}
                            type={filterType}
                            onClick={(e: any) => {
                                onToggleFilterProperties(e.target.value, `${filterItem.id}/${filterItem.filterItemValue}`)
                                onChangeFilterProperties(`${filterItem.id}/${filterItem.filterItemValue}`)
                            }}
                            value={filterItem.filterItemValue}
                        >
                            {children}
                        </S.Button>

                    </div>
                )
            }
            default:
                return (
                    <div key={filterItem.filterItemName} >
                        <S.Button
                            onClick={() => {
                                onChangeFilterProperties(filterItem.filterItemValue);
                                setfilterProperties((prevState: any) => ({ ...prevState }))
                            }}
                            style={checked ? { background: '#DBC7B8', color: '#424242' } : { background: 'transparent' }}
                            type={filterType}>
                            {children}
                        </S.Button>

                    </div>
                )
        }

    }, [filterProperties, filterName, filterType, onChangeFilterProperties, hasProprietes, onToggleFilterProperties, setfilterProperties])

    const filterContent = useMemo(() => {

        return filterCategoryItems?.map((filterItem) => {

            switch (filterItem.filterItemValue) {
                case 'lojaoffpremium': {
                    return (
                        <React.Fragment key={filterItem.filterItemValue}>
                            {filterItem.brands?.map(item => (
                                <React.Fragment key={item.filterItemValue}>
                                    <S.Button type={filterType}
                                        onClick={() => {
                                            onChangeFilterProperties(item.filterItemValue);
                                            setfilterProperties((prevState: any) => ({ ...prevState }))
                                        }}
                                        style={
                                            JSON.stringify(filterProperties.brand) === JSON.stringify(item.filterItemValue)
                                                ? { background: '#DBC7B8', color: '#424242' } : { background: 'transparent' }}
                                    >
                                        {item.filterItemName}
                                    </S.Button>
                                </React.Fragment>

                            ))}
                        </React.Fragment>
                    )
                }

                default:
                    return (
                        paramsFilter(filterItem, filterItem.filterItemName)

                    )
            }
        })
    }, [filterCategoryItems, paramsFilter, filterType, filterProperties, onChangeFilterProperties, setfilterProperties])

    return (
        <CSSTransition nodeRef={nodeRef} in={isOpen} timeout={400} classNames="top_bottom_weak_effect" unmountOnExit>
            <S.Container ref={nodeRef} >
                {filterContent}
            </S.Container>
        </CSSTransition>
    )
}

export default FilterCategoryItem